import { render } from "./CarEditCheck.vue?vue&type=template&id=38ba61ce"
import script from "./CarEditCheck.vue?vue&type=script&lang=js"
export * from "./CarEditCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__